import { useMemo } from 'react';

export const useKeymaps = () =>
  useMemo(
    () => ({
      Russian: {
        81: 'Й',
        87: 'Ц',
        69: 'У',
        82: 'К',
        84: 'Е',
        89: 'Н',
        85: 'Г',
        73: 'Ш',
        79: 'Щ',
        80: 'З',
        219: 'Х',
        221: 'Ъ',
        65: 'Ф',
        83: 'Ы',
        68: 'В',
        70: 'А',
        71: 'П',
        72: 'Р',
        74: 'О',
        75: 'Л',
        76: 'Д',
        186: 'Ж',
        192: 'Э',
        90: 'Я',
        88: 'Ч',
        67: 'С',
        86: 'М',
        66: 'И',
        78: 'Т',
        77: 'Ь',
        188: 'Б',
        190: 'Ю',
      },

      'English (qwerty)': {
        81: 'Q', // row 1
        87: 'W',
        69: 'E',
        82: 'R',
        84: 'T',
        89: 'Y',
        85: 'U',
        73: 'I',
        79: 'O',
        80: 'P',
        219: '[',
        221: ']',
        65: 'A', // row 2
        83: 'S',
        68: 'D',
        70: 'F',
        71: 'G',
        72: 'H',
        74: 'J',
        75: 'K',
        76: 'L',
        186: ';',
        192: "'",
        222: '#',
        90: 'Z', // row 3
        88: 'X',
        67: 'C',
        86: 'V',
        66: 'B',
        78: 'N',
        77: 'M',
        188: ',',
        190: '.',
        191: '/',
      },

      'English (dvorak)': {
        81: '"', // row 1
        87: '<',
        69: '>',
        82: 'P',
        84: 'Y',
        89: 'F',
        85: 'G',
        73: 'C',
        79: 'R',
        80: 'L',
        219: '?',
        221: '+',
        65: 'A', // row 2
        83: 'O',
        68: 'E',
        70: 'U',
        71: 'I',
        72: 'D',
        74: 'H',
        75: 'T',
        76: 'N',
        186: 'S',
        192: '-',
        90: ':', // row 3
        88: 'Q',
        67: 'J',
        86: 'K',
        66: 'X',
        78: 'B',
        77: 'M',
        188: 'W',
        190: 'V',
        191: 'Z',
      },
    }),
    [],
  );
